<template>
<BreadcrumbsProject
        v-if="!isDeluxeLayout"
        :breadcrumbs="[
            {
                link : '/high-level-estimates',
                title : $t('Bidding'),
                isRouterLink: true
            },
        ]"
/>

<div class="card hle-bidding-card directory-list-card">
    <div class="card-header directory-list-card__header hle-bidding-card__header">
        <div class="directory-list-card__title">
            <h4>{{ $t('Bidding Module.Bidding')}}</h4>
        </div>
        <div class="directory-list-card__actions">
            <button class="btn btn-primary directory-add-btn hle-bidding-add-btn" data-bs-toggle="modal" data-bs-target="#HleProjectAdd" @click="OpenCreateModal" >
                <i class="fa-solid fa-plus"></i>
                {{ $t('Add') }}
            </button>
        </div>
    </div>
    <div class="card-body directory-list-card__body">
        <div class="directory-list-toolbar hle-bidding-toolbar">
            <div class="directory-search hle-bidding-search">
                <i class="fa-solid fa-magnifying-glass"></i>
                <input type="search" class="form-control" v-model="searchBar" :placeholder="$t('Bidding Module.Search Name of Biddings here')" />
            </div>
            <div class="directory-pagination hle-bidding-pagination" v-if="projectList.totalPages">
                <Pagination
                    :changePage="PageChange"
                    :paginationDetails="{totalPages : projectList.totalPages, page : projectList.page || 1}"
                />
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-striped directory-table hle-bidding-table">
                <thead>
                    <tr>
                        <th>{{ $t('Bidding Module.Bidding Name') }}</th>
                        <th>{{ $t('Currency') }}</th>
                        <th>{{ $t('Office') }}</th>
                        <th class="hle-bidding-table__status">{{ $t('Status') }}</th>
                        <th>{{ $t('Created By') }}</th>
                        <th>{{ $t('Created At') }}</th>
                        <th class="hle-bidding-table__actions-heading">{{ $t('Actions') }}</th>
                    </tr>
                </thead>
                <tbody  v-if="isLoading">
                    <tr>
                        <td colspan="7" class="hle-bidding-loader">
                            <Loader />
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-if="projectList.docs.length==0">
                        <td class="text-center directory-empty-state" colspan="7" >{{$t('No data Found')}}</td>
                    </tr>
                    <tr v-for="(item,key) in projectList.docs" :key="key">
                        <td>
                            <router-link :to="{name : 'HleList', params : {id : item._id}}" class="text-capitalize directory-user-name hle-bidding-name">
                                {{item.projectName}} 
                            </router-link>
                        </td>
                        <td>
                            {{ item.currencyId?.sign }} {{ item.currencyId?.name }}
                        </td>
                        <td class="text-capitalize">
                            {{ item.officeId?.officeName }}
                        </td>
                        <td class="directory-status-col hle-bidding-table__status">
                            <span :class="['badge hle-bidding-status-pill', GetStatusClass(item.status)]">{{ GetStatusName(item.status) }}</span>
                        </td>
                        <td class="text-capitalize">
                            {{ item.createdBy?.fullname }}
                        </td>
                        <td>
                            {{ ReformatDate(item.createdAt)}}
                        </td>
                        <td class="directory-table__actions hle-bidding-table__actions">
                            <router-link :to="{name : 'HleList', params : {id :  item._id} }" class="directory-icon-btn hle-bidding-icon-btn" :title="$t('View')">
                                <i class="fa-solid fa-magnifying-glass"></i>
                            </router-link>
                            <button class="directory-icon-btn directory-icon-btn--edit hle-bidding-icon-btn" @click="OpenUpdateModal(item)"
                            data-bs-toggle="modal" data-bs-target="#HleProjectUpdate" :title="$t('Edit')"
                            > <i class="fa-solid fa-pen"></i></button>
                            <button class="directory-icon-btn directory-icon-btn--delete hle-bidding-icon-btn" @click="DeleteProject(item._id,item.projectName)" :title="$t('Delete')"> <i class="fa-solid fa-trash-can"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="hle-bidding-page-count" v-if="projectList.totalPages">
            <small>{{ $t('Showing page') }} {{projectList.page || 1}} {{ $t('of') }} {{projectList.totalPages}}</small>
        </div>
    </div>
</div>

<Modal idModal="HleProjectAdd" :headerTitle="$t('Bidding Module.Create Bidding')" modalSize="modal-md" >
    <div class="form-group">
        <label>
            {{$t('Bidding Module.Bidding Name') }}
            <span class="bidding-required-inline" v-if="!HasRequiredValue(newProject.name)">({{ $t('Required').toLowerCase() }})</span>
        </label>
        <input class="form-control" :placeholder="$t('Bidding Module.Bidding Name') " v-model="newProject.name" />
    </div>
    <div class="form-group">
        <label>
            {{ $t('Currency') }}
            <span class="bidding-required-inline" v-if="!HasRequiredValue(newProject.currencyId)">({{ $t('Required').toLowerCase() }})</span>
        </label>
        <select class="form-select" v-model="newProject.currencyId" >
            <option value="">{{ $t('Please Select') }}</option>
            <option v-for="(item, key) in boqCurrency" :key="key" :value="item._id">{{item.sign}} {{item.name}} </option>
        </select>
    </div>
    <div class="form-group">
        <label>
            {{ $t('Office in Charge') }}
            <span class="bidding-required-inline" v-if="!HasRequiredValue(newProject.officeId)">({{ $t('Required').toLowerCase() }})</span>
        </label>
        <Select2
            :dataOptions="officeList"
            indexValue="_id"
            labelName="officeName"
            :placeHolder="$t('Please Select')"
            v-model:optionValue="newProject.officeId"
        >
        </Select2>
    </div>
    <template v-slot:actions>
        <button type="button" ref="closeHleProjectAdd" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X  ' + $t('Cancel') }}</button>
        <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="isOnProcess || !isCreateProjectReady" @click="CreateProject($event.target)" ><i v-if="!isDeluxeLayout" class="fas fa-save"></i>  {{ $t('Save Changes') }}</button>
    </template>
</Modal>
<Modal idModal="HleProjectUpdate" :headerTitle="$t('Bidding Module.Update Bidding')" modalSize="modal-md" >
    <div class="form-group">
        <label>
            {{$t('Bidding Module.Bidding Name')}}
            <span class="bidding-required-inline" v-if="!HasRequiredValue(updateProject.name)">({{ $t('Required').toLowerCase() }})</span>
        </label>
        <input class="form-control" :placeholder="$t('Bidding Module.Bidding Name') " v-model="updateProject.name" />
    </div>
    <div class="form-group">
        <label>
            {{$t('Currency') }}
            <span class="bidding-required-inline" v-if="!HasRequiredValue(updateProject.currencyId)">({{ $t('Required').toLowerCase() }})</span>
        </label>
        <select class="form-select" v-model="updateProject.currencyId" >
            <option value="">{{ $t('Please Select') }}</option>
            <option v-for="(item, key) in boqCurrency" :key="key" :value="item._id">{{item.sign}} {{item.name}} </option>
        </select>
    </div>
    <div class="form-group">
        <label>
            {{$t('Office in Charge') }}
            <span class="bidding-required-inline" v-if="!HasRequiredValue(updateProject.officeId)">({{ $t('Required').toLowerCase() }})</span>
        </label>
        <Select2
            :dataOptions="officeList"
            indexValue="_id"
            labelName="officeName"
            :placeHolder="$t('Please Select')"
            v-model:optionValue="updateProject.officeId"
        >
        </Select2>
    </div>
    <template v-slot:actions>
        <button type="button" ref="closeHleProjectUpdate" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X  ' + $t('Cancel') }}</button>
        <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="isOnProcess || !isUpdateProjectReady" @click="UpdateProject($event.target)" ><i v-if="!isDeluxeLayout" class="fas fa-save"></i> {{ $t('Save Changes') }}</button>
    </template>
</Modal>
</template>

<script>
import 'dotenv/config'
import Loader from '@/components/layout/Loader.vue'
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import  {mapActions,mapGetters} from 'vuex'
import {AddHighLevelProject, UpdateHighLevelProject,GetHighLevelProjectList ,DeleteHighLevelProject} from '@/actions/boqActions.js'
import {GetOffices} from '@/actions/userActions.js'
import {LinkList,ReformatDate, ApprovalStageBoqObj} from '@/helpers/utilities.js'
import Pagination from '@/components/layout/Pagination.vue'
import Select2 from '@/components/layout/Select2.vue'


import Modal from '@/components/layout/Modal.vue'
export default {
    name : 'HleProjectList',
    components : {
        BreadcrumbsProject, Modal, Loader,
        Pagination,Select2
    },
    data (){
        return {
            projectList : {
                docs : []
            },
            pagedParams : {
                listBy : 1,
                page : 1,
                search : ''
            },
            newProject : {},
            isSaveProjectClicked :false,
            updateProject : {},
            isUpdateProjectClicked :false,
            isLoading : true,
            isOnProcess : false,
            selectedCreatedBy : { id : 1, value : 'My Biddings'},
            searchBar : '',
            creatorOptions  : [ 
                { id : 1, value : 'My Biddings'},
                { id : 2, value : 'Office Biddings'},
            ],
            timerSearch  : null,
            ApprovalStageBoqObj,
            officeList : [],
        }
    },
    mounted : async function(){
        const self = this
        self.ChangeActiveLink(LinkList.HIGH_LEVEL_ESTIMATES)
        await self.GetCurrencyListRun()
        await self.ReloadData()
        self.officeList = await GetOffices()
    },  
    computed :{
        ...mapGetters(['boqCurrency']),
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        isCreateProjectReady(){
            return this.HasRequiredValue(this.newProject.name) &&
                this.HasRequiredValue(this.newProject.currencyId) &&
                this.HasRequiredValue(this.newProject.officeId)
        },
        isUpdateProjectReady(){
            return this.HasRequiredValue(this.updateProject.name) &&
                this.HasRequiredValue(this.updateProject.currencyId) &&
                this.HasRequiredValue(this.updateProject.officeId)
        }
    },
    methods : {
        ...mapActions(['ChangeActiveLink','GetCurrencyListRun']),
        ReformatDate,
        HasRequiredValue(value){
            return String(value || '').trim().length > 0
        },
        GetStatusName(status){
            const stage = ApprovalStageBoqObj[Number(status) - 1]
            if(!stage){
                return '-'
            }
            return String(stage.name).toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase())
        },
        GetStatusClass(status){
            switch(Number(status)){
                case 1:
                case 2:
                case 3:
                    return 'hle-bidding-status-pill--pending'
                case 4:
                    return 'hle-bidding-status-pill--approval'
                case 5:
                case 8:
                    return 'hle-bidding-status-pill--approved'
                case 6:
                    return 'hle-bidding-status-pill--revision'
                default:
                    return 'hle-bidding-status-pill--neutral'
            }
        },
        async PageChange(page){
            const self = this
            self.pagedParams.page = page
            await self.ReloadData()
        },
        timerSetterSearch(callback){
            const self = this
            
            if(self.timerSearch){
                clearTimeout(self.timerSearch)
                self.timerSearch = null
            }

            self.timerSearch = setTimeout(callback,700)
        },
        async ReloadData(){
            const self = this

            self.isLoading = true
            self.projectList = await GetHighLevelProjectList(self.pagedParams)
            self.isLoading = false
        },
        OpenCreateModal(){
            this.newProject  ={
                currencyId :''
            }
        },
        async CreateProject(){

            const self = this

            if(self.isOnProcess){ return }

            let data = self.newProject

            self.isSaveProjectClicked = true
            if(!self.isCreateProjectReady){
                return
            }
            self.isSaveProjectClicked = false
            self.isOnProcess = true
            const result = await AddHighLevelProject(data)
            self.isOnProcess = false
            if(result=='OK'){
                self.$swal(self.$i18n.t('Bidding Module.Create Bidding'),self.$i18n.t('Bidding Module.Added Successfully'),'success')
                self.$refs.closeHleProjectAdd.click()
                self.ReloadData()
            }
            else{
                self.$swal(self.$i18n.t('Bidding Module.Create Bidding'),result,'warning')
            }
        },
        OpenUpdateModal(item){
            const self = this
            self.updateProject.id = item._id
            self.updateProject.currencyId = item.currencyId._id
            self.updateProject.name = item.projectName
            self.updateProject.officeId = item.officeId._id
        },
        async UpdateProject(){
            const self = this

            if(self.isOnProcess){ return }

            let data = self.updateProject

            self.isUpdateProjectClicked = true
            if(!self.isUpdateProjectReady){
                return
            }
            self.isUpdateProjectClicked = false
            self.isOnProcess = true
            const result = await UpdateHighLevelProject(data)
            self.isOnProcess = false
            if(result=='OK'){
                self.$swal(self.$i18n.t('Bidding Module.Update Bidding'),self.$i18n.t('Updated Successfully'),'success')
                self.$refs.closeHleProjectUpdate.click()
                self.ReloadData()
            }
            else{
                self.$swal(self.$i18n.t('Bidding Module.Update Bidding'),result,'warning')
            }
        },
        DeleteProject(id,name){
            const self = this
            self.$swal({
                title: self.$i18n.t('Bidding Module.Delete Bidding'),
                text : `"${name}" ${self.$i18n.t('Bidding Module.will be Deleted Permanently, Proceed?')}'`,
                showCancelButton: true,
                icon: 'warning',
                confirmButtonText: self.$i18n.t('Delete'),
                cancelButtonText : self.$i18n.t('Cancel'),
                showLoaderOnConfirm : true,
                allowOutsideClick: () => !self.$swal.isLoading(),
                preConfirm : ()=>{
                    return DeleteHighLevelProject({id : id})
                }
            }).then(async (res)=>{
                if(res.isConfirmed){
                    if(res.value=='OK'){
                        await self.ReloadData()
                        self.$swal( self.$i18n.t('Bidding Module.Delete Bidding'),'','success')
                    }else{
                        self.$swal(self.$i18n.t('Bidding Module.Delete Bidding'),res.value,'warning')
                    }
                
                }
            })
        },
    },
    watch : {
        searchBar(val) {
            const self = this
            self.pagedParams.page = 1
            self.pagedParams.search = val
            self.timerSetterSearch(async function(){
                await self.ReloadData()
            })
        },
        selectedCreatedBy(val) {
            const self = this
            self.pagedParams.page = 1
            if(val)
                self.pagedParams.listBy = val.id
            else 
                self.pagedParams.listBy = undefined
            self.timerSetterSearch(async function(){
                await self.ReloadData()
            })
        },
    }


}


</script>
